import React from 'react';
import styled from 'styled-components';

import Progress from 'antd/es/progress';
import Tooltip from 'antd/es/tooltip';

import { Text } from '../Text';

const ProgressWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  & > * {
    line-height: 4px;
  }
`;

const StyledProgressBar = styled(Progress)`
  line-height: 0;
  padding-bottom: 2px;
  
  & .ant-progress-outer {
    line-height: 0;
  }

  & .ant-progress-inner {
    border-radius: unset;
  }
`;


const ProcessBar = ({ completed, forcasted, completedColor, forcastedColor, showPrediction, ...rest }) => {
  const tooltip = {
    placement: 'top',
    title: (
      <>
        <Text color="#fff">
          {`${completed}% Current Progress (% of Completion)`}
        </Text>
        {showPrediction && (
          <>
            <br/>
            <Text color="#fff">
              {`${forcasted}% Predicted Progress (% of Completion)`}
            </Text>
          </>
        )}
      </>
    ),
    overlayStyle: {
      maxWidth: 'unset',
    }
  };

  return (
    <ProgressWrapper {...rest}>
      <Tooltip {...tooltip}>
          <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <StyledProgressBar
              type="line"
              strokeWidth={8}
              strokeColor={completedColor}
              strokeLinecap="square"
              showInfo={false}
              percent={completed}
            />
            {showPrediction && (
              <StyledProgressBar
                type="line"
                strokeWidth={8}
                strokeColor={forcastedColor}
                strokeLinecap="square"
                showInfo={false}  
                percent={forcasted}
              />
            )}
          </div>
        </Tooltip>
      
      <Text style={{ color: completedColor || forcastedColor, fontSize: '15px', lineHeight: '24px', marginLeft: '8px' }}>
        {`${completed}%`}
      </Text>
    </ProgressWrapper>
  )
};

export default ProcessBar;
